import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import TextTruncate from 'react-text-truncate'
import numeral from 'numeral'
import moment from 'moment'

import Tooltip from 'Pods/Shared/Tooltip'
import JobInfoRow from '../../Components/JobInfoRow'
import JobActions from '../../Components/JobActions'

class JobListItem extends React.Component {
  constructor() {
    super()

    this.state = {
      isMobile: true,
    }

    this.handleWindowSizeChange = this.handleWindowSizeChange.bind(this)
  }

  componentDidMount() {
    this.handleWindowSizeChange()
    window.addEventListener('resize', this.handleWindowSizeChange)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange)
  }

  handleWindowSizeChange() {
    if ((window.innerWidth < 1260) && (!this.state.isMobile)) {
      this.setState({
        isMobile: true,
      })
    } else if ((window.innerWidth >= 1260) && (this.state.isMobile)) {
      this.setState({
        isMobile: false,
      })
    }
  }

  isApplicationCountVisible() {
    if (this.props.isViewerDesigner || this.props.isPublicListing) {
      return this.props.type === 'public' && ['unapproved', 'approved'].includes(this.props.status)
    }
    return ['unapproved', 'approved'].includes(this.props.status) && ['public', 'private'].includes(this.props.type)
  }

  render() {
    const price = this.props.price || this.props.budget

    return (
      <Fragment>
        <picture>
          <source srcSet={`${this.props.image.thumbUrl} 1x, ${this.props.image.retinaThumbUrl} 2x`} />
          <img src={this.props.image.thumbUrl} alt={this.props.title} />
        </picture>
        <div className="job-list-item__content">
          <div className="job-list-item__row--upper">
            <TextTruncate
              text={this.props.title}
              truncateText="…"
              containerClassName="job-list-item__title"
              line={1}
            />
            <div className="job-list-item__price">
              {this.props.updatesCount > 0 ? (
                <Fragment>
                  <span className="job-list-item__indicator">
                    <span className="indicator indicator--square">{this.props.updatesCount}</span>
                  </span>
                  <h3 className="job-list-item__price-separated">{numeral(price).format('$0')}</h3>
                </Fragment>
              ) : (
                <h3>{numeral(price).format('$0')}</h3>
              )}
            </div>
          </div>
          <div className="job-list-item__date">
            Posted on {moment(this.props.createdAt).format('YYYY-MM-DD')}
          </div>
          <div className="job-list-item__description">
            <TextTruncate
              line={this.state.isMobile ? 5 : 2}
              text={this.props.plainDescription}
              truncateText="…"
            />
          </div>
          <div className="job-list-item__row job-list-item__row--bottom">
            <JobInfoRow
              type={this.props.type}
              deadline={this.props.deadline || undefined}
              applicationCount={this.props.applicationCount}
              isFeatured={this.props.isFeatured}
              isResellable={this.props.isResellable}
              software={this.props.software}
              status={this.props.status}
              isApplicationCountVisible={this.isApplicationCountVisible()}
              isPublicListing={this.props.isPublicListing}
              tab={this.props.tab}
              isViewerDesigner={this.props.isViewerDesigner}
            />

            {this.props.archiveStatus ? (
              <span className={`label label--cta label--${this.props.archiveStatus}`}>
                {this.props.archiveStatus === 'not_chosen' ? (
                  <Tooltip id="archive-status" content="Another applicant was chosen to work on this 3D Project.">
                    {this.props.archiveStatus.replace(/_/g, ' ')}
                  </Tooltip>
                ) : (
                  this.props.archiveStatus
                )}
              </span>
            ) : (
              (this.props.availableActions.primary.length > 0 || this.props.availableActions.secondary.length > 0) && (
                <JobActions
                  id={this.props.id}
                  slug={this.props.slug}
                  availableActions={this.props.availableActions}
                  applicationId={this.props.applicationId}
                  type={this.props.type}
                  inviteUrl={this.props.inviteUrl}
                />
              )
            )}
          </div>
        </div>
      </Fragment>
    )
  }
}

JobListItem.propTypes = {
  title: PropTypes.string.isRequired,
  plainDescription: PropTypes.string.isRequired,
  price: PropTypes.number,
  updatesCount: PropTypes.number,
  image: PropTypes.shape({
    thumbUrl: PropTypes.string.isRequired,
    retinaThumbUrl: PropTypes.string.isRequired,
  }).isRequired,
  availableActions: PropTypes.shape({
    primary: PropTypes.array,
    secondary: PropTypes.array,
  }).isRequired,
  type: PropTypes.string.isRequired,
  deadline: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  isFeatured: PropTypes.bool,
  applicationCount: PropTypes.number,
  isResellable: PropTypes.bool,
  isViewerDesigner: PropTypes.bool,
  isPublicListing: PropTypes.bool,
  software: PropTypes.array.isRequired,
  id: PropTypes.string.isRequired,
  applicationId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  tab: PropTypes.string,
  inviteUrl: PropTypes.string,
}

JobListItem.defaultProps = {
  isResellable: false,
  isFeatured: false,
  isViewerDesigner: false,
  applicationId: null,
  applicationCount: null,
  isPublicListing: false,
  deadline: null,
  updatesCount: 0,
  tab: 'applied',
  price: 0,
  availableActions: {
    primary: [],
    secondary: [],
  },
  inviteUrl: '',
}

export default JobListItem
